export default defineNuxtRouteMiddleware(async _ => {
    try {
        clearNuxtData()
    } catch (error) {
        console.log("[ClearRequestsMiddleware]", error)
    }
})